import {
  Alert,
  schAlertSeverity,
  schAlertStatus,
  schAlertType,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

const TIP =
  'A rating of C4-C6 is typically expected for unrenovated conditions. C3 is considered exceptional.';

export const aivAboveC3: AlertDefinition = ({
  compSequence,
  compType,
  order,
  propertyDataEntities,
  fullCompSequence,
}) => {
  if (!order.hasArvOption || compType !== 'aiv') return [];

  return compSequence
    .map((compID, index) => {
      const compData = propertyDataEntities[compID] as CompPropertyDataState | undefined;
      const condition = compData?.compData.editableData.improvements?.uadCondition;
      if (condition !== 1 && condition !== 2) return undefined;

      const compIndex = fullCompSequence?.indexOf(compID);
      const compLabel = `Comp ${compIndex !== undefined ? compIndex + 1 : index + 1}`;
      const targetCellKey = `${compID}-editableData.improvements.uadCondition`;

      return {
        type: schAlertType.enum.aivAboveC3,
        status: schAlertStatus.enum.active,
        severity: schAlertSeverity.enum.warning,
        orderType: ['appraisify'],
        compType,
        message: `${compLabel} has a higher than expected condition rating for an AIV`,
        propertyID: compID,
        triggers: getAlertTriggers({
          fixRoute: schPairedCostRouteItem.enum.features,
          order,
          includeUpdate: true,
        }),
        fixingInfo: {
          tips: TIP,
          pairedCostRouteItem: schPairedCostRouteItem.enum.features,
          fixingMethod: ['action'],
          commentAlwaysRequired: false,
          targetCellKey,
          targetCellKeys: [targetCellKey],
        },
      } as Alert;
    })
    .filter((alert): alert is Alert => alert !== undefined);
};
